import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getQuotes({ commit }, { projectId, params = {} }) {
    return axios.get(`/projects/${projectId}/quotes/search`, { params })
  },
  getQuote({ commit }, id) {
    return axios.get(`/quotes/${id}`)
  },
  createQuote({ commit }, data) {
    return axios.post('/quotes', data)
  },
  updateQuote({ commit }, data) {
    return axios.put(`/quotes/${data.id}`, data)
  },
  updateQuoteStatus({ commit }, data) {
    return axios.put(`/quotes/${data.id}/change-status`, data)
  },
  updateItemsAdditional({ commit }, {id, data}) {
    return axios.put(`/quotes/${id}/items-additional`, data)
  },
  acceptQuote({ commit }, id) {
    return axios.post(`/quotes/${id}/accept`)
  },
  cloneQuote({ commit }, id) {
    return axios.post(`/quotes/${id}/clone`)
  },
  downloadQuote({ commit }, quote) {
    return axios
      .get(`/quotes/${quote.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${quote.document_name}.pdf`)
      })
  },
  deleteQuote({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/quotes/${payload.id}/delete`, payload)
  },
  declineQuote({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/quotes/${payload.id}/decline`, payload)
  },
}
